// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qjUf0GoyBV8LoiaQ .m2DzbxuVN8EgVtYq .HlRh2iFtiJwy8z_R{width:344px;height:-webkit-fit-content;height:fit-content;padding:16px;border-radius:5px;border-width:1px;border-style:solid;border-color:var(--py-neutral-3);float:right}.qjUf0GoyBV8LoiaQ .m2DzbxuVN8EgVtYq .M_BzJiOBm8UQLZo_{max-width:424px;height:-webkit-fit-content;height:fit-content}.qjUf0GoyBV8LoiaQ .kjQZ2YvM30F9MZQb{margin:0 auto;max-width:150px}.qjUf0GoyBV8LoiaQ .kjQZ2YvM30F9MZQb .Zkiu8K63bPoLw8CN{float:right}.qjUf0GoyBV8LoiaQ .kjQZ2YvM30F9MZQb .mQfxVPGpcgYRQW3G{white-space:nowrap}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dynamicEmployees": `qjUf0GoyBV8LoiaQ`,
	"body": `m2DzbxuVN8EgVtYq`,
	"queryBuilderCardColumn": `HlRh2iFtiJwy8z_R`,
	"queryCardsColumn": `M_BzJiOBm8UQLZo_`,
	"buttonWrapper": `kjQZ2YvM30F9MZQb`,
	"backButton": `Zkiu8K63bPoLw8CN`,
	"saveButton": `mQfxVPGpcgYRQW3G`
};
export default ___CSS_LOADER_EXPORT___;
